import type { TurboStreamActions } from "@hotwired/turbo";
import { registerDataGridActions } from "./data_grid";

export function registerClioUITurboStreamActions(
  streamActions: TurboStreamActions
) {
  registerDataGridActions(streamActions);
}
